<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <h2>Social</h2>
      <b-nav>
        <b-nav-item :to="{name: 'social_accounts'}" exact exact-active-class="tab_active">Accounts</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>

import {auth} from '@/main.js'

export default {
  props: ['profile', 'user', 'site'],
}
</script>

<style scoped>

</style>
